import LatestEpisodeConsumptionPage from 'src/pages/tv-shows/details/[showName]/[showId]/latest';
export default LatestEpisodeConsumptionPage;
